import { render, staticRenderFns } from "./LinkIFC.vue?vue&type=template&id=18b55f54&scoped=true"
import script from "./LinkIFC.vue?vue&type=script&lang=js"
export * from "./LinkIFC.vue?vue&type=script&lang=js"
import style0 from "./LinkIFC.vue?vue&type=style&index=0&id=18b55f54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b55f54",
  null
  
)

export default component.exports